// Hooks
import { useSettings } from 'shared/utils/useSettings'

/**
 * @function useBrandingColor
 *
 * @description A hook that returns the branding color from the window options (if set) or from the account settings.
 *
 * @returns {string} The branding color.
 */
export const useBrandingColor = () => {
  const settings = useSettings('store.brand_color')

  const options = window.booqableOptions

  return options?.primaryColor?.length ? options.primaryColor : settings
}
